import { render, staticRenderFns } from "./r-tip.vue?vue&type=template&id=1265486e&scoped=true&"
import script from "./r-tip.vue?vue&type=script&lang=js&"
export * from "./r-tip.vue?vue&type=script&lang=js&"
import style0 from "./r-tip.vue?vue&type=style&index=0&id=1265486e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265486e",
  null
  
)

export default component.exports